import { render, staticRenderFns } from "./OnlinePayments.vue?vue&type=template&id=54be2b80&scoped=true&"
import script from "./OnlinePayments.vue?vue&type=script&lang=js&"
export * from "./OnlinePayments.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePayments.vue?vue&type=style&index=0&id=54be2b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be2b80",
  null
  
)

export default component.exports